import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var BadRequestError = function BadRequestError(data) {
    _classCallCheck(this, BadRequestError);

    this.data = data;
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/bad-request.js
// module id = ./src/abstractions/errors/bad-request.js
// module chunks = 34